import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toHandlers as _toHandlers, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Arguments")
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["textContent", "title"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "mt-8" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Accounts")
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["textContent", "title"]
const _hoisted_9 = ["textContent"]
const _hoisted_10 = ["textContent"]
const _hoisted_11 = { key: 1 }

import { computed, toRefs } from 'vue';
import { Idl } from '@project-serum/anchor';
import { parseAnchorTypeSummary } from '@/utils';
import { useModal } from '@/composables';


export default /*#__PURE__*/_defineComponent({
  props: {
    instruction: null,
    idl: null,
    close: null
  },
  setup(__props: any) {

const props = __props as {
  instruction: {
    name: string,
    instructions: object[],
    args: { type: object }[],
  },
  idl: Idl,
  close:() => void,
}



const { instruction, idl, close } = toRefs(props);
const { open: openModal } = useModal();
const argumentsWithSummary = computed(() => instruction.value.args.map((arg) => ({
  summary: parseAnchorTypeSummary(arg.type),
  ...arg,
})));

return (_ctx: any,_cache: any) => {
  const _component_base_label = _resolveComponent("base-label")!
  const _component_icon_pen = _resolveComponent("icon-pen")!
  const _component_base_dropdown = _resolveComponent("base-dropdown")!
  const _component_icon_fingerprint = _resolveComponent("icon-fingerprint")!
  const _component_base_sidepage = _resolveComponent("base-sidepage")!

  return (_openBlock(), _createBlock(_component_base_sidepage, {
    close: _unref(close),
    title: _unref(instruction).name,
    subtitle: "Explore the instruction's schema."
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_base_label, null, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        (_unref(argumentsWithSummary).length > 0)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(argumentsWithSummary), (arg) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: arg.name,
                  class: "flex px-2 py-1 odd:bg-indigo-50/50 rounded-lg"
                }, [
                  _createElementVNode("div", {
                    textContent: _toDisplayString(arg.name),
                    title: arg.name,
                    class: "mr-auto font-mono truncate"
                  }, null, 8, _hoisted_3),
                  (_openBlock(), _createBlock(_resolveDynamicComponent(arg.summary.hasMore ? 'button' : 'div'), {
                    class: _normalizeClass(["ml-4 text-sm font-mono", arg.summary.hasMore ? 'hover:font-semibold' : '']),
                    title: arg.summary.text,
                    innerHTML: arg.summary.html,
                    onClick: ($event: any) => (arg.summary.hasMore && _unref(openModal)('sidepage-anchor-type-explorer', { type: arg, idl: _unref(idl), kind: 'argument', initialStatus: 'Types Expanded' }))
                  }, null, 8, ["class", "title", "innerHTML", "onClick"]))
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, "—"))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_base_label, null, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        (_unref(instruction).accounts.length > 0)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(instruction).accounts, (account) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: account.name,
                  class: "flex px-2 py-1 odd:bg-indigo-50/50 rounded-lg"
                }, [
                  _createElementVNode("div", {
                    textContent: _toDisplayString(account.name),
                    title: account.name,
                    class: "mr-auto font-mono truncate"
                  }, null, 8, _hoisted_8),
                  _createVNode(_component_base_dropdown, {
                    class: "ml-4",
                    "menu-class": "px-2 py-1",
                    placement: "bottom"
                  }, {
                    default: _withCtx(({ hoverListeners }) => [
                      _createVNode(_component_icon_pen, _mergeProps(_toHandlers(hoverListeners), {
                        class: ["w-5 h-5", account.isMut ? 'text-indigo-500' : 'text-gray-400']
                      }), null, 16, ["class"])
                    ]),
                    menu: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "whitespace-nowrap text-sm",
                        textContent: _toDisplayString(account.isMut ? 'Mutable' : 'Not Mutable')
                      }, null, 8, _hoisted_9)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_base_dropdown, {
                    class: "ml-4",
                    "menu-class": "px-2 py-1",
                    placement: "bottom"
                  }, {
                    default: _withCtx(({ hoverListeners }) => [
                      _createVNode(_component_icon_fingerprint, _mergeProps(_toHandlers(hoverListeners), {
                        class: ["w-5 h-5", account.isSigner ? 'text-indigo-500' : 'text-gray-400']
                      }), null, 16, ["class"])
                    ]),
                    menu: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "whitespace-nowrap text-sm",
                        textContent: _toDisplayString(account.isSigner ? 'Signer' : 'Not Signer')
                      }, null, 8, _hoisted_10)
                    ]),
                    _: 2
                  }, 1024)
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, "—"))
      ])
    ]),
    _: 1
  }, 8, ["close", "title"]))
}
}

})